'use client';

import { Box } from '@mui/material';
import LoadingAnimation from '@/src/components/SvgLoadingAnimation';

export default function TenantLoadingState() {
  return (
    <Box
      sx={(theme) => ({
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1000,
        color: theme.palette.foamGreen['600']
      })}
    >
      <LoadingAnimation height={64} width={64} />
    </Box>
  );
}
